import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a004c24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content mx-auto d-grid gap-3" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "app-chooser-icon app-chooser-icon--teal" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "app-chooser-text" }
const _hoisted_6 = { class: "app-chooser-title" }
const _hoisted_7 = { class: "app-chooser-desc" }
const _hoisted_8 = { class: "app-chooser-chevron" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "app-chooser-icon app-chooser-icon--blue" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "app-chooser-text" }
const _hoisted_13 = { class: "app-chooser-title" }
const _hoisted_14 = { class: "app-chooser-chevron" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "app-chooser-text" }
const _hoisted_19 = { class: "app-chooser-title" }
const _hoisted_20 = { class: "app-chooser-desc" }
const _hoisted_21 = { class: "app-chooser-chevron" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "app-chooser-icon app-chooser-icon--gray" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "app-chooser-text" }
const _hoisted_26 = { class: "app-chooser-title" }
const _hoisted_27 = { class: "app-chooser-chevron" }
const _hoisted_28 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { "position-center": "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (this.isAuthenticated && this.getCustomerMainDomain)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: 'https://' + this.getCustomerMainDomain.domain_url,
              target: "_blank",
              class: "app-chooser-btn app-chooser-btn--lg"
            }, [
              _createElementVNode("span", _hoisted_3, [
                _createElementVNode("img", {
                  src: require('@/assets/images/apps/website.svg'),
                  alt: "",
                  width: "20",
                  height: "20"
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("viewWebsite")), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(this.getCustomerMainDomain.domain_url), 1)
              ]),
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("img", {
                  src: require('@/assets/images/apps/chevron.svg'),
                  alt: "",
                  width: "14",
                  height: "14"
                }, null, 8, _hoisted_9)
              ])
            ], 8, _hoisted_2))
          : _createCommentVNode("", true),
        (!this.isAuthenticated)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (this.login && this.login(...args)), ["prevent"])),
              class: "app-chooser-btn app-chooser-btn--lg"
            }, [
              _createElementVNode("span", _hoisted_10, [
                _createElementVNode("img", {
                  src: require('@/assets/images/apps/login.svg'),
                  alt: "",
                  width: "20",
                  height: "20"
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("manageContentAndSettings")), 1)
              ]),
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("img", {
                  src: require('@/assets/images/apps/chevron.svg'),
                  alt: "",
                  width: "14",
                  height: "14"
                }, null, 8, _hoisted_15)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.otherApps, (app) => {
          return (_openBlock(), _createElementBlock("a", {
            key: app.code,
            href: app.url,
            target: "_blank",
            class: "app-chooser-btn app-chooser-btn--lg"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["app-chooser-icon", 'app-chooser-icon--' + app.variant])
            }, [
              _createElementVNode("img", {
                src: require('@/assets/images/apps/' + app.icon + '.svg'),
                alt: "",
                width: "20",
                height: "20"
              }, null, 8, _hoisted_17)
            ], 2),
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(this.appTitle(app)), 1),
              _createElementVNode("span", _hoisted_20, _toDisplayString(this.appDescription(app)), 1)
            ]),
            _createElementVNode("span", _hoisted_21, [
              _createElementVNode("img", {
                src: require('@/assets/images/apps/chevron.svg'),
                alt: "",
                width: "14",
                height: "14"
              }, null, 8, _hoisted_22)
            ])
          ], 8, _hoisted_16))
        }), 128)),
        _createVNode(_component_router_link, {
          to: {name: 'support'},
          class: "app-chooser-btn app-chooser-btn--lg"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_23, [
              _createElementVNode("img", {
                src: require('@/assets/images/apps/help.svg'),
                alt: "",
                width: "20",
                height: "20"
              }, null, 8, _hoisted_24)
            ]),
            _createElementVNode("span", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("needHelp") + "?"), 1)
            ]),
            _createElementVNode("span", _hoisted_27, [
              _createElementVNode("img", {
                src: require('@/assets/images/apps/chevron.svg'),
                alt: "",
                width: "14",
                height: "14"
              }, null, 8, _hoisted_28)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}